import type { FC, ReactNode } from "react";
import styles from "./styles.module.scss";

interface Props {
  content: ReactNode;
}

export const DropdownContent: FC<Props> = ({ content }) => {
  return <div className={styles.container}>{content}</div>;
};
